import { Route, Routes } from "react-router";
import RootLayout from "./app/RootLayout";
import LoginPage from "./app/login/LoginPage";
import HomeLayout from "./app/home/HomeLayout";
import DashboardPage from "./app/home/DashboardPage";
import AccountsPage from "./app/home/admin/accounts/page";
import BillingReportPage from "./app/home/billing/billing-report/page";
import BillingTablePage from "./app/home/billing/billing-table/page";
import TopupTransactionPage from "./app/home/billing/topup-transaction/page";
import TransactionHistoryPage from "./app/home/billing/transaction-history/page";
import PaymentOutboxPage from "./app/home/billing/payment-outbox/page";
import EInvoiceNotificationSettingPage from "./app/home/billing/einvoice-notification-setting/page";
import FeeLadderPage from "./app/home/category/fee-ladder/page";
import TollAreaPage from "./app/home/category/toll-area/page";
import UnitTypePage from "./app/home/category/unit-type/page";
import SampleTestPage from "./app/home/customer-support/sample-test/page";
import SendNotificationPage from "./app/home/customer-support/send-notification/page";
import IndexReportPage from "./app/home/meter-reading/index-report/page";
import ReadMeterPeriodPage from "./app/home/meter-reading/read-meter-period/page";
import CustomerRequestPage from "./app/home/customer-support/request/page";
import WaterSupplySuspensionPage from "./app/home/customer-support/suspension/page";
import WaterIndexPage from "./app/home/meter-reading/water-index/page";
import AuditLogsPage from "./app/home/admin/logs/page";
import FeeLadderLevelPage from "./app/home/category/fee-ladder/level/page";
import WaterSuspensionLevelPage from "./app/home/customer-support/suspension/level/page";
import ContractsPage from "./app/home/customer/contracts/page";
import CustomerReportPage from "./app/home/customer/customer-report/page";
import WaterRegistrationPage from "./app/home/customer/water-registration/page";
import AccountGroupsPage from "./app/home/admin/account-groups/page";
import AdminAppsPage from "./app/home/admin/apps/page";
import MatBaoSettingsPage from "./app/home/admin/matbao-settings/page";
import CustomerCodeSettingsPage from "./app/home/admin/customer-code-settings/page";
import EInvoiceRoutingSettingsPage from "./app/home/admin/einvoice-routing-settings/page";
import IntegrationSettingsPage from "./app/home/admin/integration-settings/page";
import DepartmentsPage from "./app/home/category/departments/page";
import PaymentPointPage from "./app/home/customer-support/payment-point/page";
import ElectronicContractPage from "./app/home/customer/electronic-contract/page";
import ChatbotPage from "./app/chatbot/ChatbotPage";
import ArticlePage from "./app/home/customer-support/article/page";

export const AppRouter: React.FC<{}> = () => {

    return (
        <Routes>
        <Route path="/" element={<RootLayout ></RootLayout>} >
            <Route path="login" element={<LoginPage />}></Route>
            <Route path="chatbot" element={<ChatbotPage />}></Route>
            <Route path="/" element={<HomeLayout />}>
            <Route index element={<DashboardPage />} />
                <Route path="customer">
                    <Route path="contracts" element={<ContractsPage />} />
                    <Route path="water-registration" element={<WaterRegistrationPage />} />
                    <Route path="customer-report" element={<CustomerReportPage />} />
                    <Route path="electronic-contract" element={<ElectronicContractPage />} />
                </Route>
                <Route path="meter-reading">
                    <Route path="water-index" element={<WaterIndexPage />} />
                    <Route path="read-meter-period" element={<ReadMeterPeriodPage />} />
                    <Route path="index-report" element={<IndexReportPage />} />
                </Route>
                <Route path="billing">
                    <Route path="billing-table" element={<BillingTablePage />} />
                    <Route path="topup-transaction" element={<TopupTransactionPage />} />
                    <Route path="transaction-history" element={<TransactionHistoryPage />} />
                    <Route path="payment-outbox" element={<PaymentOutboxPage />} />
                    <Route path="einvoice-notification-setting" element={<EInvoiceNotificationSettingPage />} />
                    <Route path="billing-report" element={<BillingReportPage />} />
                </Route>
                <Route path="customer-support">
                    <Route path="request" element={<CustomerRequestPage />} />
                    <Route path="send-notification" element={<SendNotificationPage />} />
                    <Route path="suspension" element={<WaterSupplySuspensionPage />} />
                    <Route path="suspension/level" element={<WaterSuspensionLevelPage />} />
                    <Route path="sample-test" element={<SampleTestPage />} />
                    <Route path="payment-point" element={<PaymentPointPage />} />
                    <Route path="article" element={<ArticlePage />} />
                </Route>
                <Route path="category">
                    <Route path="toll-area" element={<TollAreaPage />} />
                    <Route path="unit-type" element={<UnitTypePage />} />
                    <Route path="fee-ladder" element={<FeeLadderPage />} />
                    <Route path="departments" element={<DepartmentsPage />} />
                    <Route path="fee-ladder/level" element={<FeeLadderLevelPage />} />

                </Route>
                <Route path="admin">
                    <Route path="customer-code-settings" element={<CustomerCodeSettingsPage />} />
                    <Route path="integration-settings" element={<IntegrationSettingsPage />} />
                    <Route path="einvoice-routing-settings" element={<EInvoiceRoutingSettingsPage />} />
                    <Route path="matbao-settings" element={<MatBaoSettingsPage />} />
                    <Route path="accounts" element={<AccountsPage />} />
                    <Route path="account-groups" element={<AccountGroupsPage />} />
                    <Route path="logs" element={<AuditLogsPage />} />
                    <Route path="apps" element={<AdminAppsPage />} />
                </Route>
            </Route>
        </Route>
        </Routes>
    );

}
